import ConfirmAgeField from './ConfirmAgeField';
import SourceOfTheAssetsField from './SourceOfTheAssetsField';

export const STEP_COMPONENTS_TYPES = {
  CONFIRM_AGE_FIELD: 'confirm-age-field',
  SOURCE_OF_THE_ASSETS_FIELD: 'source-of-the-assets-field'
};

export const stepComponentsMap = {
  [STEP_COMPONENTS_TYPES.CONFIRM_AGE_FIELD]: ConfirmAgeField,
  [STEP_COMPONENTS_TYPES.SOURCE_OF_THE_ASSETS_FIELD]: SourceOfTheAssetsField
};
